<div class="container">
  <div class="title-container">
    <div>{{title}} &nbsp;</div>
    <mat-icon>{{docTypeIcon}}</mat-icon>
    <!-- <img *ngIf="isMapLink" class="icon-type" src="../../../assets/sm-document-256.png" />
    <img *ngIf="isGDocLink" class="icon-type" src="../../../assets/doc-google-256.png" /> -->
  </div>
  <img class="qrcode" src="{{qrcode}}" />
  @if (safeMessage) {
    <span class="message" [innerHTML]="safeMessage"></span>
  }
  <button mat-stroked-button matTooltip="{{'SHARE_COPY_LINK' | translate}}" (click)="copyLink()">
    <mat-icon>insert_link</mat-icon>
    {{"SHARE_COPY_LINK" | translate}}
  </button>
</div>
